<template>
	<div class="myCont">
		<div class="main">
			<div class="infosearch">
        <span class="labelTit">申请时间:</span>
        <el-date-picker v-model="createDate" type="date" align="right" value-format="yyyy-MM-dd HH:mm:ss" style="width:150px;margin:0 10px" placeholder="请选择时间"></el-date-picker>
        <span class="labelTit">申请类型:</span>
				<el-select v-model="applyStatus" style="width:120px;margin-right: 10px">
				  <el-option label='全部' :value="''"></el-option>
				  <el-option v-for='item in applyTypeOption' :value='item.value' :key='item.value' :label='item.name'></el-option>
				</el-select>
				<el-button class="searchBtn" v-loading.fullscreen.lock="fullscreenLoading" @click="enterSeach"></el-button>
				<el-button class="addMems" @click="businessAdd">新增申请</el-button>
			</div>
			<el-table :data="tableData" ref="multipleTable"	class="myMemTable" style="width: 100%" :header-cell-style="{background:'#EFF1F5'}">
				<el-table-column label='申请编号' prop='orderNo' show-overflow-tooltip align="center"></el-table-column>
				<el-table-column label='申请时间' prop='createDate' show-overflow-tooltip align="center"></el-table-column>
				<el-table-column label='申请人' prop='applyName' show-overflow-tooltip align="center"></el-table-column>
				<el-table-column label='处理状态' prop='applyStatus' show-overflow-tooltip align="center"></el-table-column>
				<el-table-column label='处理人' prop='dealName' show-overflow-tooltip align="center"></el-table-column>
				<el-table-column label='处理时间' prop='dealTime' show-overflow-tooltip align="center"></el-table-column>
				<el-table-column label='下店人员' prop='assistName' show-overflow-tooltip align="center"></el-table-column>
				<el-table-column label='下店时间' prop='signInDate' show-overflow-tooltip align="center"></el-table-column>
				<el-table-column align="center" label="操作" class-name="operation">
					<template slot-scope="scope">
						<el-button size="small" @click="warchEval(scope.row.id)">查看</el-button>
            <el-button type="danger" size="small" v-if="scope.row.applyStatusName == '待处理'" @click="evaRemove(scope.row.id)">取消</el-button>
						<el-button type="warning" v-if="scope.row.applyStatusName == '待评价'" size="small" @click="evaluatE(scope.row)" plain>评价</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination  v-if=total
        @size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="[10, 20, 30, 40]"
				:page-size="pageSize"
				background
				layout="total, sizes, prev, pager, next, jumper"
				:total="total" style="margin-top: 20px;text-align:right">
			</el-pagination>
		</div>
    <el-dialog title="对本次下店服务评价" :visible.sync="dialogVisible" :center="true" top="80px" width="350px">
      <el-form label-width="90px">
        <el-form-item label='下店服务:'>
          <el-rate v-model="innServices" style="line-height:2.5;"></el-rate>
        </el-form-item>
        <el-form-item label='销售活动:'>
          <el-rate v-model="salesActivities" style="line-height:2.5;"></el-rate>
        </el-form-item>
        <el-form-item label='培训服务:'>
          <el-rate v-model="trainingServices" style="line-height:2.5;"></el-rate>
        </el-form-item>
        <el-form-item label='输入评价:'>
          <el-input type="textarea" v-model="evaluation" style="width:80%;height:100px;" placeholder="请输入,限制200字" resize="none" maxlength="200"></el-input>
        </el-form-item>
        <el-row style="width:70%;margin: 8% auto 3%;">
          <el-button style="padding: 9px 13px;" @click="cancelEva">取消评价</el-button>
          <el-button type='primary' style="padding: 9px 13px;margin-right:3%;" @click="submitEva">提交评价</el-button>
        </el-row>
      </el-form>
    </el-dialog>
	</div>
</template>
<script type="text/javascript">
import { formatDate} from '@/components/common/js/date.js';
import {selectAllApplyOrders, innAssistEvaluation, cancleApplyOrder} from "@/api";
export default {
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      total: 0,
      fullscreenLoading: false,
      tableData: [],
      // createDate:formatDate(new Date(),'yyyy-MM-dd 00:00:00'),
      createDate:'',
      orderType:'',
      applyStatus: '',
      applyTypeOption:[
        {value:1, name:'待处理'},
        {value:2, name:'待下店'},
        {value:3, name:'待离店'},
        {value:4, name:'待评价'},
        {value:5, name:'已完成'},
        {value:6, name:'已取消'}
      ],
      dialogVisible:false,
      salesActivities:0,
      trainingServices:0,
      innServices:0,
      evaluation:'',
      menuId:''
    };
  },
  created() {
    this.selectAl()
  },
  activated() {
    this.selectAl()
  },
  methods: {
    evaRemove(id){
      cancleApplyOrder({
        systemType:this.$store.state.userInfo.brandId,
        innId:id
      }).then(res => {
        this.$message({
          message:res.msg,
          type:'warning'
        });
        this.selectAl();
      });
    },
    warchEval(id){
      this.$router.push("/cliqueBusinessCenter/cliqueDtails=" + id);
      this.$store.commit('setAlivePage',this.currentPage)
    },
    evaluatE(val){
      this.menuId = val
      if(this.menuId.isShopEvaluation == 0){
        this.$message({
          message:'下店人员尚未对门店进行评价',
          type:'warning'
        });
      }else{
        this.dialogVisible = true
      }
    },
    submitEva(){
      innAssistEvaluation({
        innId:this.menuId.id,
        innServices:this.innServices,
        trainingServices:this.trainingServices,
        salesActivities:this.salesActivities,
        evaluation:this.evaluation,
        systemType:this.$store.state.userInfo.brandId
      }).then(res => {
       this.innServices = 0;
       this.trainingServices = 0;
       this.salesActivities = 0;
       this.evaluation = '';
       this.$message({
         message:res.msg,
         type:'success'
       });
       this.selectAl();
       this.cancelEva();
      });
    },
    selectAl(){
      let postData = {
        shopId:this.$store.state.userInfo.shopId,
        systemType:this.$store.state.userInfo.brandId,
        createDate:this.createDate,
        applyStatus:this.applyStatus,
        pageSize:this.pageSize,
        pageNumber:this.currentPage,
        currentPage: this.currentPage
      }
      selectAllApplyOrders(postData).then(res => {
        if(res.code == '20001'){
          this.total = res.obj.total;
          this.tableData = res.obj.rows;
          this.tableData.forEach(item =>{
            if(item.createDate){
              item.createDate = formatDate(item.createDate, 'yyyy-MM-dd HH:mm')
            }
            if(item.signInDate){
              item.signInDate = formatDate(item.signInDate, 'yyyy-MM-dd HH:mm')
            }
            if(item.dealTime){
              item.dealTime = formatDate(item.dealTime, 'yyyy-MM-dd HH:mm')
            }
            for (let i of this.applyTypeOption){
              if(item.applyStatus == i.value){
                item.applyStatus = i.name
              }
            }
          });
        }
      });
    },
    enterSeach() {
      this.currentPage = 1;
      this.selectAl();
    },
    businessAdd(){
      this.$router.push("/cliqueBusinessCenter/addApply");
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.selectAl();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.selectAl();
    },
    cancelEva(){
      this.innServices = 0;
      this.trainingServices = 0;
      this.salesActivities = 0;
      this.evaluation = '';
      this.dialogVisible = false
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  padding: 25px 0;
  .infosearch {
    .el-input__inner {
      border-radius: 20px;
    }
    .searchBtn {
      width: 47px;
      height: 38px;
      background: #f83b56 url(../../assets/images/store/btn_datalist_search.png)
        no-repeat center;
    }
    .addMems {
      color: #fff;
      font-weight: bold;
      text-indent: 20px;
      background: #3b404f url(../../assets/images/store/btn_datalist_add.png)
        no-repeat 15px center;
    }
  }
  .myMemTable {
    margin-top: 25px;
    border: 1px solid #D5D9E3;
    .el-button--mini {
      padding: 8px;
      font-weight: bold;
    }
    .el-button + .el-button {
      margin-left: 0;
    }
    .deleteBtn {
      border: 1px solid #f96479;
      color: #f83b56;
      font-weight: bold;
    }
  }
  .defaults,
  .emptys {
    height: 600px;
    background: url(../../assets/images/store/img_vip_inquire.png) no-repeat
      center;
    text-align: center;
    font-size: 15px;
    color: #666;
    padding-top: 450px;
  }
  .emptys {
    background: url(../../assets/images/store/img_vip_none.png) no-repeat center;
  }
}
</style>
<style lang="less">
.myMemTable {
  .operation {
    .cell {
      padding: 0;
    }
  }
  .el-table__header{
    background:rgb(239, 241, 245);
  }
  .highLight {
    background: #EFF1F5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/groupWork/cliqueWork.vue